import mainPageModel           from '../main-navigation/MainPageModel';
import RuleSettingsEditorModel from './RuleSettingsEditorModel';
import ToolbarButtons          from './TimeOffAccrualRuleEditorButtons';
import DataQueries             from '../graphql/Queries';

export default class TimeOffAccrualRuleEditorModel extends RuleSettingsEditorModel {
  constructor() {
    super('Time Off Accrual', 'wk7MRP34QQiLy8SQYhIrg8');
    this.ToolbarButtons = ToolbarButtons;
  }

  canRunAccrualRules(): boolean {
    return !this.viewOnly;
  }

  async runAccrualRules() {
    if (!this.canRunAccrualRules()) return;
    return DataQueries.runTimeOffAccrualRules();
  }

  get access(): boolean {
    return mainPageModel.timeOffBalancesRulesAccess;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canEditTimeOffBalancesRules;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditTimeOffBalancesRules;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canEditTimeOffBalancesRules;
  }
}
